// @treatink/sdk singleton. Dynamically imported so the SDK stays out of the initial
// bundle entirely while VITE_TK_DESIGNER is off. Never import '@treatink/sdk' statically
// from app code — always go through getTreatink().

import { TREATINK_API_BASE, TREATINK_PK, TREATINK_CHANNEL, TK_MODE } from "../config/endpoints";

let instancePromise = null;

export function getTreatink() {
  if (!instancePromise) {
    instancePromise = import("@treatink/sdk").then(({ Treatink }) => {
      const tk = Treatink.init({
        apiKey: TREATINK_PK || "pk_test_fixtures",
        channel: TREATINK_CHANNEL,
        mode: TK_MODE,
        apiBaseUrl: TREATINK_API_BASE,
      });
      tk.on("error", (err) => {
        // Surfaced for observability; designer-level errors also arrive via onError.
        console.error("[treatink-sdk]", err?.code, err?.message);
      });
      return tk;
    });
    instancePromise.catch(() => {
      instancePromise = null; // allow retry after a failed init/import
    });
  }
  return instancePromise;
}

// Test seam
export function __resetTreatinkForTests() {
  instancePromise = null;
}
